<template>
    <div class="bcgl">
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <div slot="header">
                    <el-row style="margin-bottom: 20px">
                        <el-col :span="12" style="text-align: right">
                            <div style="line-height: 3rem; font-size: 1.5rem;">装备出库</div>
                        </el-col>
                        <el-col :span="12" style="text-align: right">
                            <el-button
                                    v-if="isAuth('equip:out')"
                                    type="primary"
                                    style="display: inline"
                                    @click="batchOut()">批量出库
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row style="text-align: left">
                        <el-form :inline="true" :model="form" @keyup.enter.native="selectChanged3">
                            <el-form-item>
                                <el-select clearable :disabled="deptdisable" @change="selectChanged2" filterable
                                           v-model="form.dept" placeholder="请选择大队">
                                    <el-option
                                            v-for="item in depts"
                                            :key="item.bmid"
                                            :label="item.bmmc"
                                            :value="item.bmid"
                                            :disabled="deptdisable">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-select clearable :disabled="childdeptdisable" v-model="form.childDept"
                                           placeholder="请选择班组" clearable>
                                    <el-option
                                            v-for="item in childDept"
                                            :key="item.bmid"
                                            :label="item.bmmc"
                                            :value="item.bmid"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-input style="width: 150px" placeholder="姓名" v-model="form.name"
                                          prefix-icon="el-icon-user" clearable>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input style="width: 160px" placeholder="岗位" v-model="form.gw"
                                          prefix-icon="el-icon-user" clearable>
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-select v-model="form.needEquip" clearable placeholder="需要装备" style="width: 110px">
                                    <el-option label="否" value="0"></el-option>
                                    <el-option label="是" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="年龄" prop="age">
                                <el-row>
                                    <el-input-number
                                    @change="changeIndex"
                                    v-model="form.minAge"
                                    clearable
                                    controls-position="right"
                                    :min="0"
                                    :max="500"
                                    style="width: 100px"
                                    ></el-input-number>
                                    <el-input-number
                                    @change="changeIndex"
                                    v-model="form.maxAge"
                                    clearable
                                    controls-position="right"
                                    :min="0"
                                    :max="500"
                                    style="width: 100px"
                                    ></el-input-number>
                                </el-row>
                            </el-form-item>
                            <el-form-item>
                                <el-button @click="selectChanged3()">查询</el-button>
                                <el-button @click="showInfo2()" v-if="isAuth('equip:out')" type="primary">大队出库
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-row>
                </div>

                <el-table
                        :data="contractList" v-loading="loading" style="text-align: center; width: 100%;">
                    <el-table-column prop="username" label="用户编号" width="150">

                    </el-table-column>
                    <el-table-column prop="xm" label="用户名" width="100">
                        <template slot-scope="scope">
                            <el-button type="text" @click="showUser(scope.row)">{{
                                scope.row.xm
                                }}
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="岗位" prop="gw" width="200">
                    </el-table-column>
                    <el-table-column label="年龄">
                        <template slot-scope="scope">
                            {{getAge(scope.row.csrq)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="出生日期">
                        <template slot-scope="scope">
                            {{scope.row.csrq}}
                        </template>
                    </el-table-column>
                    <el-table-column label="身份证号码" width="200">
                        <template slot-scope="scope">
                            {{scope.row.sfzhm}}
                        </template>
                    </el-table-column>
                    <el-table-column label="需要装备">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.needEquip===1" type="info">否</el-tag>
                            <el-tag v-else type="success">是</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="进公司日期" prop="jrgsrq" width="150">
                    </el-table-column>
                    <el-table-column label="部门" width="150">
                        <template slot-scope="scope">
                            <span>{{getBm(scope.row)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="春秋装尺寸" prop="uniformsaSize" width="100">
                    </el-table-column>
                    <el-table-column label="夏装尺寸" prop="uniformsSize" width="100">
                    </el-table-column>
                    <el-table-column label="冬装尺寸" prop="uniformwSize" width="100">
                    </el-table-column>
                    <el-table-column label="鞋子尺寸" prop="shoseSize" width="100">
                    </el-table-column>
                    <el-table-column label="帽子尺寸" prop="hatSize" width="100">
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="170" :render-header="renderHeader">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" v-if="isAuth('equip:out') && scope.row.needEquip !== 1"
                                       @click="showInfo(scope.row)">出库
                            </el-button>
                            <el-button type="text" size="mini" v-if="isAuth('equip:out') && scope.row.needEquip !== 1"
                                       @click="setSize(scope.row)">设置尺寸
                            </el-button>
                            <el-button type="text" size="mini" v-if="isAuth('equip:out')"
                                       @click="updateNeedEquip(scope.row)">{{scope.row.needEquip===1?'发装备':'不发装备'}}
                            </el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="currentNo"
                               :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                </el-pagination>
            </el-card>
        </div>
        <el-dialog
            style="text-align: left"
            title="导出"
            :visible.sync="exportVisible">
			<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
			<el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
				<el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
			</el-checkbox-group>
			<form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/equip/out/exportEquipOutExcel?access_token='+this.$store.getters.token"  target="_blank">
				<input type="hidden" v-for="(value,key,index) in form" :name="key"  :value="value" />
				<input type="hidden" name="fileds" value="" ref="fileds"/>
			</form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="exportVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportExcel">确 定</el-button>
            </span>
		</el-dialog>

        <con-info v-if="showInfoVisible" ref="showInfo"></con-info>
        <set-size v-if="setSizeVisible" ref="setSize" @refreshDataList="getUserList"></set-size>
        <out-bm v-if="showInfoVisible2" ref="showInfo2"></out-bm>
        <batch-in v-if="batchVisible" ref="batchin" @refreshDataList="getUserList"></batch-in>
    </div>
</template>
<script>
    import {Component, Vue} from 'vue-property-decorator'

    import ConInfo from './equip-out'
    import OutBm from './equip-outbm'
    import SetSize from './set-size'
    import BatchIn from './bacth-in'
    import Template from "@/template.vue";
    // import fa from "element-ui/src/locale/lang/fa";
    const exportFields=[
		{value:"username",name:"用户编号"},
		{value:"xm",name:"姓名"},
		{value:"gw",name:"岗位"},
		{value:"jrgsrq",name:"进入公司日期"},
		{value:"bmmc",name:"部门"},
		{value:"uniformsaSize",name:"春秋装尺寸"},
		{value:"uniformsSize",name:"夏装尺寸"},
		{value:"uniformwSize",name:"冬装尺寸"},
		{value:"shoseSize",name:"鞋子尺寸"},
		{value:"hatSize",name:"帽子尺寸"}
	]
    @Component({
        name: 'contractinfo',
        components: {
            Template,
            ConInfo,
            OutBm,
            SetSize,
            BatchIn
        }
    })
    export default class contractinfo extends Vue {
        customerVisible = false
        currentNo = 1;
        pageSize = 10;
        pageTotal = 0;
        childDept = [];
        activeNames = [];
        customerUserVisible = false
        showbmxxVisible = false;
        customerList = []
        showfileVisible = false
        showInfoVisible = false
        setSizeVisible = false
        showInfoVisible2 = false
        exportVisible = false
        isIndeterminate = false
        checkAll = false
        fieldList = []
        fields = exportFields
        filedValues = exportFields.map(item => item.value)
        types = []
        form = {
            dept: '',
            needEquip: '',
            childDept: '',
            name: '',
            isleave: 0,
            gw: '',
            minAge: '',
            maxAge: ''
        }
        startTime = []
        endTime = []
        childdeptdisable = false
        deptdisable = false
        amount = ['', '']
        contractList = []
        batchVisible = false
        bmxx = []
        loading = false;
        dataListSelections = [];
        sjbm = []
        depts = []
        selectBm = ''

        created() {
            // alert("111")
			// let searchParams = {
			// 	pageSize: this.pageSize,
			// 	pageNum: this.currentNo,
			// 	dept: this.form.dept,
			// 	needEquip: this.form.needEquip,
			// 	childDept: this.form.childDept,
			// 	name:this.form.name,
			// 	gw:this.form.gw
			// }
			// debugger
			this.pageSize = this.$store.state.searchParams.pageSize;
			this.currentNo = this.$store.state.searchParams.pageNum;
			this.form.dept = this.$store.state.searchParams.dept;
			this.form.needEquip = this.$store.state.searchParams.needEquip;
			this.form.childDept = this.$store.state.searchParams.childDept;
			this.form.name = this.$store.state.searchParams.name;
			this.form.gw = this.$store.state.searchParams.gw;
			// this.selectChanged3();
			this.getDepts()
            this.getbmxx()
        }

        handleSizeChange(val) {
            this.pageSize = val;
            this.getUserList();
        }

        handleCurrentChange(val) {
            this.currentNo = val;
			let searchParams = {
				pageSize: this.pageSize,
				pageNum: this.currentNo,
				dept: this.form.dept,
				needEquip: this.form.needEquip,
				childDept: this.form.childDept,
				name:this.form.name,
				gw:this.form.gw
			}
			this.$store.commit('updateSearchParams', searchParams)
            this.getUserList();
        }

        showExportDialog() {
			this.exportVisible = true
		}

        handleCheckAllChange(val) {
			this.fieldList = val ? this.filedValues: [];
			this.isIndeterminate = false;
		}

        handleCheckedItemChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.filedValues.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
		}

        renderHeader (h) {
			return (
					<div class="clearfix">
						<span>操作</span>
						<el-button style="padding:5px;float:right" size="mini"
								   onClick={()=>this.showExportDialog()}>导出</el-button></div>
			)
		}

        exportExcel() {
            var filedLast = this.fields.filter(filed=>{
                return this.fieldList.indexOf(filed.value) !==-1
            })
            if(filedLast && filedLast.length>0) {
                this.form.page = this.currentNo;
                this.form.pagesize = 10
                this.form.userid = this.$store.getters.username
                this.$refs.fileds.value = JSON.stringify(filedLast)
                this.$refs.exportForm.submit();
            } else {
                this.$message({
                    message: '请选择字段',
                    type: 'error',
                    duration: 1500
                })
                return
            }
        }


        showInfo(row) {

            this.showInfoVisible = true
            this.$nextTick(() => {
                this.$refs.showInfo.init(row.id, 0)
            })
        }

        updateNeedEquip(row) {

            this.$confirm(`确定对【${row.xm}】进行${row.needEquip === 1 ? '发装备' : '不发装备'}操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: '/bjba/equip/out/updateNeedEquip',
                    data: [row.id],
                    method: 'post'
                }).then(({data}) => {
                    if (data && data.code === 200) {
                        this.$message
                        ({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.getUserList()
                    } else if (data && data.code == 500) {
                        this.$message
                        ({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                })
            }).catch(() => {
            })
        }

        setSize(row) {

            this.setSizeVisible = true
            var data = {
                userid: '',
                uniformsaSize: '',
                uniformsSize: '',
                uniformwSize: '',
                shoseSize: '',
                hatSize: ''
            }
            data.userid = row.id
            data.uniformsaSize = row.uniformsaSize
            data.uniformsSize = row.uniformsSize
            data.uniformwSize = row.uniformwSize
            data.shoseSize = row.shoseSize
            data.hatSize = row.hatSize
            this.$nextTick(() => {
                this.$refs.setSize.init(data)
            })
        }

        showInfo2(row) {

            this.showInfoVisible2 = true
            this.$nextTick(() => {
                this.$refs.showInfo2.init()
            })
        }

        batchOut() {
            this.batchVisible = true
            this.$nextTick(() => {
                this.$refs.batchin.init()
            })
        }

        addOrUpdate(val) {

            if (!this.dataListSelections || this.dataListSelections.length == 0) {
                this.$message.warning("请选择装备")
                return
            }
            let ids = this.dataListSelections.map(item => {
                return item.id
            })
            this.customerVisible = true
            this.$nextTick(() => {
                this.$refs.customer.init(ids)
            })
        }

        getDepts() {
            let that = this;
            this.$request.get('/bjba/kqtj/getFirstMentForUser', {
                params: {
                    userid: this.$store.getters.username
                }

            }).then(res => {
                that.depts = res.data
                if (this.depts && this.depts[0]) {
                    var zzdyqc = this.$store.getters.user.zzdyqc;
                    if (zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;

                        if (zw) {
                            if (zw == '01' || zw == '02' || zw == '03') {
                                this.form.dept = that.depts[0].bmid
                                this.deptdisable = true
                                if (zw != '01') {
                                    this.childdeptdisable = true;
                                }
                                this.selectChanged2(this.form.dept)
                            }
                            this.selectChanged2(this.form.dept)
                        } else {
                            this.selectChanged2(this.form.dept)
                        }

                    } else {
                        this.selectChanged2(this.form.dept)
                    }
                }
            })
        }

        getbmxx() {
            let that = this;
            this.$request.get('/bjba/yhgl/getbmxx').then(res => {
                console.log("bmxx:", res);
                that.bmxx = res.data;
            })
        }

        showUser(user) {
            // debugger
            // alert(this.$store.state.searchParams.pageSize)
            let searchParams = {
                pageSize: this.pageSize,
                pageNum: this.currentNo,
                dept: this.form.dept,
                needEquip: this.form.needEquip,
                childDept: this.form.childDept,
				name:this.form.name,
				gw:this.form.gw
            }
            this.$store.commit('updateSearchParams', searchParams)
            // alert(this.$store.state.searchParams.pageSize)
            this.$router.push({
                path: "/bjba/grzx",
                query: {username: user.username},
            });
        }

        getBm(user) {
            var ubmid;
            if (user.ddbz) ubmid = user.ddbz;
            else ubmid = user.zzdyqc
            for (var i = 0; i < this.bmxx.length; i++) {

                if (this.bmxx[i].bmid == ubmid) {
                    return this.bmxx[i].bmmc
                }
            }
        }

        selectChanged2(value) {
            this.currentNo = 1
			// debugger
			this.currentNo = this.$store.state.searchParams.pageNum;
            this.childDept = []
            this.form.childDept = ''
			this.form.childDept = this.$store.state.searchParams.childDept
            this.$request({
                method: 'get',
                url: '/bjba/kqtj/getMentForUser2',
                params: {
                    fbmid: value,
                    userid: this.$store.getters.username
                }
            }).then((response) => {

                this.childDept = response.data;
                var zzdyqc = this.$store.getters.user.zzdyqc;
                if (zzdyqc != this.CONST_ZN_BM) {
                    var zw = this.$store.getters.user.zw;
                    if (zw) {
                        if (zw == '02' || zw == '03') {
                            if (this.childDept[0]) {
                                this.form.childDept = this.childDept[0].bmid

                            }
                        }
                    }
                }
                this.getUserList();
            }).catch((err) => {
                console.log(err)
            })
        }

        selectChanged3(value) {
            this.currentNo = 1;
            // debugger
			let searchParams = {
				pageSize: this.pageSize,
				pageNum: this.currentNo,
				dept: this.form.dept,
				needEquip: this.form.needEquip,
				childDept: this.form.childDept,
				name:this.form.name,
				gw:this.form.gw
			}
			this.$store.commit('updateSearchParams', searchParams)
			this.getUserList();
        }

        getUserList() {
            this.loading = true
            this.form.page = this.currentNo;
            this.form.pagesize = 10
            this.form.userid = this.$store.getters.username
            this.$request.get('/bjba/yhgl/getUserList', {
                params: this.form
            }).then(res => {
                const {
                    data
                } = res
                console.log("列表数据：", data)
                this.contractList = data.data
                this.pageTotal = data.total
                this.loading = false
            }).catch(err => {
                this.$message({
                    message: '获取用户列表出现异常!',
                    type: 'error',
                    center: true,
                    showClose: true
                })
                this.loading = false
                console.log(err)
            })
        }

        getAge(strBirthday) {
            var age = ''
            if (strBirthday != '') {
                var subYNum = Number(strBirthday.substring(0,4))
                var nowDate = new Date();
                var year = Number(nowDate.getFullYear())
                age = year - subYNum
            } 
            return age
        }
    }
</script>
<style lang="scss" scoped>
    .bcgl {
    }
</style>
